/*
 * @Author: wangbaihe
 * @Date: 2022-09-15 18:41:07
 * @LastEditors: wangbaihe
 * @LastEditTime: 2023-09-06 17:14:58
 * @FilePath: \common-mediax\src\apis\MediaCloudNis\QA.js
 * @Description:
 */
import { createAPI } from '@common'

export default {
  // 获取问政详情
  getNisQaDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0efubjm', 'get', config),
  // 获取问政详情,不显示loading，用于悬浮显示内容
  getNisQaDetailNoLoading: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0efubjm', 'get', config, {
      neverLoading: true
    }),
  // 获取问政设置分类管理等信息
  getNisQaconfigure: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0dpogjh', 'get', config),
  postNisQaconfigure: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0dpogjh', 'post', config),
  getNisQaH5Config: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0dpogjh', 'get', config),
  postNisQaH5Config: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0dpogjh', 'post', config),
  getNisQAH5QRCode: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0hvjefRSDpef', 'get', config),
  // 新建问政
  postNisQa: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb', 'post', config),
  // 修改问政
  putNisQa: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb', 'PUT', config),
  // 读分类
  getNisQaCategorys: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0dbufhpsz', 'get', config),
  // 读部门
  getNisQaDepartments: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0efqbsunfou', 'get', config),
  // 查询查重的问政列表
  getNisQaSimilarListdata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0tjnjmbs0mjtuebub', 'get', config),
  // 问政-回复
  postNisQaReplay: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0sfqmz', 'POST', config),
  // 问政-不通过
  postNisQaReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0sfkfdu', 'POST', config),
  // 问政-通过
  postNisQaPass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0qbtt', 'POST', config),
  // 手动上锁
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60bdujpot0qsfbdujpo', 'get', config, {
      neverLoading: true
    }),

  // 手动解锁
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 问政-删除
  postNisQaDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0efmfuf', 'POST', config),
  // 删除回复
  postNisQaReplayDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0sfqmz0efmfuf', 'POST', config),
  // 问政-置顶
  postNisQaTop: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0upq', 'POST', config),
  // 问政-取消置顶
  postNisQaCancelTop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0upq0dbodfm', 'POST', config),
  getE5Actions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60bdujpot', 'get', config, vconfig),
  // 评论导出
  postQaDiscussExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0rb0fyqpsu', 'post', config, {
      timeout: 12000000
    }),
  // 新建问政推荐
  postColumnModules: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0sfdpnnfoe0rb', 'post', config),
  //还原推荐
  postColumnModulesRollBack: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0sfdpnnfoe0spmmCbdl', 'post', config),
  // 修改问政推荐
  putColumnModules: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0sfdpnnfoe0rb', 'put', config),
  // 获取问政推荐详情
  getColumnModules: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0sfdpnnfoe', 'GET', config),
  // 新建、修改页面初始化参数
  getColumnModulesInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0sfdpnnfoe0joju', 'GET', config),
  // 问政推荐内容排序
  getColumnModulesSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0sfdpnnfoe0tpsu', 'POST', config),
  //问政自定义推荐更新排序
  updateModuleOrder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0sfdpnnfoe0vqebufNpevmfPsefs',
      'POST',
      config
    ),
}
